import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { HomePage } from '@/pages/HomePage';
import { AboutPage } from '@/pages/AboutPage';
import { BloodGroupsPage } from '@/pages/BloodGroupsPage';
import { GalleryPage } from '@/pages/GalleryPage';
import { DonorsPage } from '@/pages/DonorsPage';
import { CampsPage } from '@/pages/CampsPage';
import { ContactPage } from '@/pages/ContactPage';
import './App.css';

function App() {
  const BASE_URL = import.meta.env.BASE_URL;
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blood-groups" element={<BloodGroupsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/donors" element={<DonorsPage />} />
            <Route path="/camps" element={<CampsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        {/* Footer */}
        <footer className="bg-neutral-900 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="flex flex-col">
                <div className="flex items-center mb-4">
                  <Link to="/" className="mr-3">
                    <img
                      src={`${BASE_URL}images/nav logo.png`}
                      alt="Navjeevan Blood Centre"
                      className="h-14 w-auto md:h-16"
                      decoding="async"
                      loading="lazy"
                    />
                  </Link>
                  <span className="text-lg md:text-xl font-bold text-white leading-tight">
                    Navjeevan Blood Center
                  </span>
                </div>
                <p className="text-body text-neutral-300 mb-4">
                  Dedicated to providing safe, reliable blood products and exceptional service to our community.
                </p>
                <div className="mt-auto">
                  <div className="flex items-center space-x-2">
                    <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold">B</span>
                    </div>
                    <span className="text-small text-neutral-400">Serving the community since 6th August 2009</span>
                  </div>
                </div>
              </div>
              <div>
                <h4 className="text-body font-semibold mb-4">Quick Links</h4>
                <ul className="space-y-2">
                  <li><Link to="/contact" className="text-body text-neutral-300 hover:text-white transition-colors">Become a Donor</Link></li>
                  <li><Link to="/about" className="text-body text-neutral-300 hover:text-white transition-colors">About Us</Link></li>
                  <li><Link to="/camps" className="text-body text-neutral-300 hover:text-white transition-colors">Host a Blood Drive</Link></li>
                  <li><Link to="/blood-groups" className="text-body text-neutral-300 hover:text-white transition-colors">Blood Types</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="text-body font-semibold mb-4">Contact Info</h4>
                <div className="space-y-2 text-body text-neutral-300">
                  <p>D. No. 18-77/78, 1st floor, Rudra Complex,</p>
                  <p>Street No. 3, V.V. Nagar Road, Kamala Nagar,</p>
                  <p>Opp. Manepally Jewellers,</p>
                  <p>Metro Pillar No. 1556, Chaitanyapuri,</p>
                  <p>Dilsukhnagar, Hyderabad-60.</p>
                  <p>Phone: 6302122760, 9032187760</p>
                </div>
              </div>
              <div>
                <h4 className="text-body font-semibold mb-4">Hours</h4>
                <div className="space-y-2 text-body text-neutral-300">
                  <p>Mon - Sat: 10:00 AM - 6:00 PM</p>
                  <p>Sunday: Closed (Sunday holiday)</p>
                  <p className="text-semantic-warning">Hours may vary on public holidays</p>
                </div>
              </div>
            </div>
            <div className="border-t border-neutral-700 mt-12 pt-8 text-center">
              <p className="text-body text-neutral-400">
                &copy; 2025 Navjeevan Blood Center. All rights reserved. | Licensed by State Health Department
              </p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
